import { memo } from 'react';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import PropTypes from 'prop-types';
import {
  FooterWrapper,
  FooterContent,
  FooterArrows,
  ArrowUp,
  ArrowDown,
} from './Footer.styled';
// import { useFormikContext } from 'formik';

const Footer = ({
  nextArrowClick,
  prevArrowClick,
  disableArrows = false,
  children,
}) => {
  // const form = useFormikContext();

  return (
    <FooterWrapper>
      <FooterContent>{children}</FooterContent>

      <FooterArrows>
        <ArrowUp onClick={prevArrowClick} disabled={disableArrows}>
          <IoIosArrowUp />
        </ArrowUp>
        {!nextArrowClick ? (
          <ArrowDown
            // onClick={() => {
            //   form && form.submitForm();
            // }}
            disabled={disableArrows}
            type='submit'
          >
            <IoIosArrowDown />
          </ArrowDown>
        ) : (
          <ArrowDown onClick={nextArrowClick} disabled={disableArrows}>
            <IoIosArrowDown />
          </ArrowDown>
        )}
      </FooterArrows>
    </FooterWrapper>
  );
};

Footer.propTypes = {
  children: PropTypes.node,
  nextArrowClick: PropTypes.func,
  prevArrowClick: PropTypes.func,
  disableArrows: PropTypes.bool,
};

export default memo(Footer);
